import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "report-row-name" }
const _hoisted_2 = {
  key: 0,
  class: "report-row-breadcrumb"
}
const _hoisted_3 = {
  key: 1,
  class: "report-row-refreshed"
}

import { ref } from "vue";
import { DocumentChartBarIcon } from "@heroicons/vue/24/solid";
import ReportRowMenu from "@/components/reports/ReportRowMenu.vue";
import type { ReportItem, ReportExportFormat } from "@/types/reports";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportRow',
  props: {
    report: {},
    breadcrumb: {}
  },
  emits: ["select", "toggle-favorite", "download"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const menuRef = ref<InstanceType<typeof ReportRowMenu> | null>(null);

function onContextMenu(e: MouseEvent) {
  menuRef.value?.openAt(e.clientX, e.clientY);
}

function formatRefreshed(val?: string): string {
  if (!val) return "---";
  // EF returns DateTime without a timezone indicator; append Z so the browser
  // always parses it as UTC instead of local time.
  const utcVal = /Z|[+-]\d{2}:?\d{2}$/.test(val) ? val : val + "Z";
  const d = new Date(utcVal);
  if (isNaN(d.getTime()) || d.getFullYear() <= 1) return "---";

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Chicago",
    month: "2-digit",
    day: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).formatToParts(d);

  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? "";
  const date = `${get("month")}/${get("day")}/${get("year")}`;
  const time = `${get("hour")}:${get("minute")}:${get("second")}${get("dayPeriod").toLowerCase()}`;
  return `${date} | ${time}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "report-row-wrap",
    onContextmenu: _withModifiers(onContextMenu, ["prevent"])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "report-row",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', __props.report)))
    }, [
      _createVNode(_unref(DocumentChartBarIcon), { class: "report-row-icon" }),
      _createElementVNode("span", _hoisted_1, _toDisplayString(__props.report.displayName), 1),
      (__props.breadcrumb)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.breadcrumb), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(formatRefreshed(__props.report.lastRefreshedAtUtc)), 1))
    ]),
    _createVNode(ReportRowMenu, {
      ref_key: "menuRef",
      ref: menuRef,
      report: __props.report,
      onView: _cache[1] || (_cache[1] = ($event: any) => (emit('select', props.report))),
      onToggleFavorite: _cache[2] || (_cache[2] = ($event: any) => (emit('toggle-favorite', props.report))),
      onDownload: _cache[3] || (_cache[3] = (fmt) => emit('download', props.report, fmt))
    }, null, 8, ["report"])
  ], 32))
}
}

})